"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var styledLayout_1 = require("../base/styledLayout");
var functions_1 = require("../../utils/functions");
var ButtonType;
(function (ButtonType) {
    ButtonType["Primary"] = "ty-primary";
    ButtonType["Secondary"] = "ty-secondary";
    ButtonType["Notr"] = "ty-notr";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
exports.Button = function (_a) {
    var children = _a.children, _b = _a.type, type = _b === void 0 ? 'button' : _b, _c = _a.onClick, onClick = _c === void 0 ? functions_1.NOOP : _c, _d = _a.buttonType, buttonType = _d === void 0 ? "ty-primary" /* Primary */ : _d, _e = _a.size, size = _e === void 0 ? "small" /* Small */ : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, forwardedRef = _a.forwardedRef;
    var buttonClassName = classnames_1.default('ty-button', 'ty-bordered', 'ty-transition', "ty-input-" + size, buttonType);
    return (React.createElement(styledLayout_1.StyledLayout, { type: type, disabled: disabled, onClick: onClick, elementType: "button" /* Button */, className: buttonClassName, fontWeight: "ty-font-w-semi-bold" /* SemiBold */, forwardedRef: forwardedRef }, children));
};
